import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRoute, Router } from "@angular/router";

@Injectable()
export class CampaignViewerUserGuard implements CanActivate {
  constructor(
    private router: Router,
    private _activatedRoute: ActivatedRoute
  ) {}

  canActivate() {
    let userProfile = JSON.parse(window.localStorage.getItem("userProfile"));
    console.log(this._activatedRoute.url);
    if (userProfile.role == "Campaign Viewer") {
      this.router.navigate(["pages/marketing-report"]);
      return false;
    } else return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/campaign-viewer-user.guard.ts